export default __webpack_public_path__ + "static/banner-3-a9ca3719c8add307992ab465ea1cbd49.jpg";